import { first } from '@execonline-inc/collections';
import { Maybe, fromNullable, just } from 'maybeasy';

const isMultiValue = <T>(v: T | ReadonlyArray<T>): v is ReadonlyArray<T> => Array.isArray(v);

const getFirstOrSelf = <T>(v: T | ReadonlyArray<T>): Maybe<T> =>
  isMultiValue(v) ? first(v) : just(v);

export const normalizeValue = <T>(v: T | ReadonlyArray<T> | null): Maybe<T> =>
  fromNullable(v).andThen(getFirstOrSelf);
